import Vue from "vue";
import Vuex from "vuex";
import tool from "../util/util.js";
Vue.use(Vuex);
const state = {
  isShow: false,
  activeName: "login",
  userMsg: {},
  remember: {}, //本地存储
  isRemember: false, //本地存储
  height: 0
};
const mutations = {
  setIsShow(state, isShow) {
    state.isShow = isShow;
  },
  setActiveName(state, activeName) {
    state.activeName = activeName;
  },
  setUserMsg(state, userMsg) {
    localStorage.setItem("userMsg", JSON.stringify(userMsg));
    state.userMsg = userMsg;
  },
  setRemember(state, remember) {
    localStorage.setItem("remember", JSON.stringify(remember));
    state.remember = remember;
  },
  setIsRemember(state, isRemember) {
    localStorage.setItem("isRemember", isRemember);
    state.isRemember = isRemember;
  },
  setHeight(state, height) {
    state.height = height;
  }
};
const actions = {
  commitIsShow({ commit }, isShow) {
    commit("setIsShow", isShow);
  },
  commitActiveName({ commit }, activeName) {
    commit("setActiveName", activeName);
  },
  commitUserMsg({ commit }, userMsg) {
    commit("setUserMsg", userMsg);
  },
  commitRemember({ commit }, remember) {
    commit("setRemember", remember);
  },
  commitIsRemember({ commit }, isRemember) {
    commit("setIsRemember", isRemember);
  },
  commitHeight({ commit }, height) {
    commit("setHeight", height);
  }
};
const getters = {
  getIsShow(state) {
    return state.isShow;
  },
  getActiveName(state) {
    return state.activeName;
  },
  getUserMsg(state) {
    return JSON.parse(state.userMsg);
  },
  getRemember(state) {
    return JSON.parse(state.remember);
  },
  getIsRemember(state) {
    return state.isRemember;
  },
  getHeight(state) {
    return state.height;
  }
};
export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});
tool.init(state, ["userMsg", "remember", "isRemember"]);
